<p *ngIf="!updateAvailable" class="versionText" [ngClass]="[alignment, cssClass]">
  v{{ this.version }}
</p>
<p
  *ngIf="updateAvailable"
  (click)="promptUser()"
  class="versionTextGlow"
  [ngClass]="[alignment, cssClass]"
>
  v{{ this.version }}
</p>
